import Ripple from '../ripple';
import { defineComponent } from 'vue';
import { props } from './props';
import { toSizeUnit } from '../utils/elements';
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = n => (_pushScopeId(""), n = n(), _popScopeId(), n);

var _hoisted_1 = ["src", "alt"];
var _hoisted_2 = {
  key: 0,
  class: "var-card__title"
};
var _hoisted_3 = {
  key: 0,
  class: "var-card__subtitle"
};
var _hoisted_4 = {
  key: 0,
  class: "var-card__description"
};
var _hoisted_5 = {
  key: 0,
  class: "var-card__footer"
};
export function render(_ctx, _cache) {
  var _directive_ripple = _resolveDirective("ripple");

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["var-card", [_ctx.elevation ? "var-elevation--" + _ctx.elevation : 'var-elevation--2']]),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onClick && _ctx.onClick(...arguments);
    })
  }, [_renderSlot(_ctx.$slots, "image", {}, () => [_ctx.src ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "var-card__image",
    style: _normalizeStyle({
      objectFit: _ctx.fit,
      height: _ctx.toSizeUnit(_ctx.height)
    }),
    src: _ctx.src,
    alt: _ctx.alt
  }, null, 12
  /* STYLE, PROPS */
  , _hoisted_1)) : _createCommentVNode("v-if", true)]), _renderSlot(_ctx.$slots, "title", {}, () => [_ctx.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1
  /* TEXT */
  )) : _createCommentVNode("v-if", true)]), _renderSlot(_ctx.$slots, "subtitle", {}, () => [_ctx.subtitle ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.subtitle), 1
  /* TEXT */
  )) : _createCommentVNode("v-if", true)]), _renderSlot(_ctx.$slots, "description", {}, () => [_ctx.description ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.description), 1
  /* TEXT */
  )) : _createCommentVNode("v-if", true)]), _ctx.$slots.extra ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_renderSlot(_ctx.$slots, "extra")])) : _createCommentVNode("v-if", true)], 2
  /* CLASS */
  )), [[_directive_ripple, {
    disabled: !_ctx.ripple
  }]]);
}
export default defineComponent({
  render,
  name: 'VarCard',
  directives: {
    Ripple
  },
  props,

  setup() {
    return {
      toSizeUnit
    };
  }

});